import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import * as EcommerceActions from '../actions/ecommerce-navigation.action';
import {DbResponse} from "../../shared/interceptors/db-response";
import {filter, map, mergeMap} from 'rxjs/operators';
import {NavigationService} from "../../websites/website/ecommerce/ecommerce-menu/navigation.service";
import {LoadEcommerceMenuList} from "../actions/ecommerce-navigation.action";

@Injectable()
export class EcommerceNavigationEffect {

  constructor(
    private _actions$: Actions,
    private _navigationService: NavigationService,
  ) {
  }

  loadEcommerceMenuList$ = createEffect(() => this._actions$.pipe(
    ofType(EcommerceActions.LOAD_ECOMMERCE_MENU_LIST),
    mergeMap((action: LoadEcommerceMenuList) => {
      const {websiteId} = action.payload;
      return this._navigationService.getMenus(websiteId)
        .pipe(
          filter((response: DbResponse) => !!response),
          map((response: DbResponse) => {
            if (response.success && response.data) {
              return new EcommerceActions.LoadEcommerceMenuListSuccess({
                menus: response.data.menus,
                websiteId
              });
            }
            return new EcommerceActions.LoadEcommerceMenuListFail({websiteId});
          })
        );
    })
  ));

}
